import { Components, Theme } from '@mui/material'

const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontFamily: theme.fonts.family.PlusJakartaSans,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '20px',
      color: theme.typographyColors.typographyThree,
      position: 'relative',
      marginBottom: 10,
      WebkitTransform: 'none',

      '&.MuiInputLabel-shrink': {
        position: 'relative',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        color: theme.typographyColors.typographyThree,
        WebkitTransform: 'none',
      },
      '&.MuiFormLabel-filled': {
        position: 'relative',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        color: theme.typographyColors.typographyThree,
        WebkitTransform: 'none',
      },
      '&.Mui-focused': {
        position: 'relative',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        color: theme.typographyColors.typographyThree,
        WebkitTransform: 'none',
      },
      '&.Mui-error': {
        position: 'relative',
        fontWeight: 400,
        fontSize: 16,
        lineHeight: '20px',
        color: theme.typographyColors.typographyThree,
        WebkitTransform: 'none',
      },
    }),
  },
}

export default MuiFormLabel
